import { render, staticRenderFns } from "./maincard.vue?vue&type=template&id=67e5f504&"
import script from "./maincard.vue?vue&type=script&lang=js&"
export * from "./maincard.vue?vue&type=script&lang=js&"
import style0 from "./maincard.vue?vue&type=style&index=0&id=67e5f504&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports